import React from "react";
import { Form, Input, Select, Checkbox } from "antd";

const BasicDataTab: React.FC<{
  form: any;
  isEditing: boolean;
  accountOptions: any[];
  storeOptions: any[];
  categoriesOptions: any[];
  countryOptions: any[];
}> = ({
  form,
  isEditing,
  accountOptions,
  storeOptions,
  categoriesOptions,
  countryOptions,
}) => {
  console.log(categoriesOptions);

  return (
    <div className="grid grid-cols-3 gap-3">
      {isEditing && (
        <Form.Item
          name="ProductID"
          label="كود المنتج"
          rules={[{ required: true }]}
        >
          <Input disabled />
        </Form.Item>
      )}
      <Form.Item name="ProductNo" label="رقم المنتج">
        <Input />
      </Form.Item>
      <Form.Item
        name="Productname"
        label="اسم المنتج"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="ProdEngName" label="الاسم بالإنجليزية">
        <Input />
      </Form.Item>
      <Form.Item
        name="CategoryID"
        label="نوع المنتج"
        rules={[{ required: true }]}
      >
        <Select options={categoriesOptions} />
      </Form.Item>

      <Form.Item name="CountryId" label="البلد">
        <Select options={countryOptions} />
      </Form.Item>
      <Form.Item name="PurchPrice" label="سعر الشراء">
        <Input type="number" />
      </Form.Item>
      <Form.Item name="AccId" label="الحساب" rules={[{ required: true }]}>
        <Select options={accountOptions} />
      </Form.Item>
      <Form.Item name="Marka" label="العلامة التجارية">
        <Input />
      </Form.Item>
      <Form.Item name="Modale" label="الموديل">
        <Input />
      </Form.Item>
      <Form.Item name="IsSpecial" valuePropName="checked">
        <Checkbox>منتج خاص</Checkbox>
      </Form.Item>
      <Form.Item name="IsPrintBarcode" valuePropName="checked">
        <Checkbox>طباعة باركود</Checkbox>
      </Form.Item>
      <Form.Item name="IsWebItem" valuePropName="checked">
        <Checkbox>ظهور في الويب</Checkbox>
      </Form.Item>
      <Form.Item name="StoreId" label="المخزن" rules={[{ required: true }]}>
        <Select options={storeOptions} />
      </Form.Item>
      <Form.Item name="MainDesc" label="الوصف الرئيسي">
        <Input.TextArea rows={3} />
      </Form.Item>
    </div>
  );
};

export default BasicDataTab;
